import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { isValidColor, isDark, getColorBlock } from 'utils/ui/colors';

/**
 * `getThemeSection` covers four main cases:
 *
 * 1. When `name` is called with the name of a theme section
 * (as defined in theme.sections), it will simply return that section
 * object.
 *
 * 2. When `name` is the name of a colorBlock (as defined in
 * theme.globals.colorBlocks), a new section object is generated
 * based on the colorBlock's color value, which will be used as the
 * section's background colour. Contrasting foreground colours will be
 * generated.
 *
 * 3. When `name` is the name of an icon or another unknown string,
 * it may or may not have an associated colorBlock. If it does, or if
 * the name is a valid colour itself, the function will return that
 * colour, and otherwise `undefined`.
 *
 * 4. When the `withBackgroundImage` option is enabled, a new section object
 * is generated that's specifically geared for ensuring readability of text
 * on background images. With this option enabled, only the `background`
 * will be based on the passed-in `name` property (i.e. the theme section
 * or color block), all other values will be hard-coded.
 */

function getThemeSection(_ref) {
  var theme = _ref.theme,
    name = _ref.name,
    withBackgroundImage = _ref.withBackgroundImage;
  // If the passed in name isn't the name of a section,
  // we treat it as a "color block"
  var isThemeSection = name in theme.sections;
  var localThemeSection = theme.sections[name];
  if (withBackgroundImage) {
    var _background = (localThemeSection === null || localThemeSection === void 0 ? void 0 : localThemeSection.background) || 'grey';
    if (!isThemeSection && typeof name === 'string') {
      var colorBlockBackground = getColorBlock(name, theme);
      if (isValidColor(colorBlockBackground)) {
        _background = colorBlockBackground;
      }
    }
    return _objectSpread(_objectSpread({}, localThemeSection), {}, {
      text: 'white',
      links: 'white',
      background: _background,
      shade: 'black',
      textDimStrength: 0.8,
      shadeStrength: 0.6,
      lineStrength: 0.8
    });
  }
  if (isThemeSection) {
    return localThemeSection;
  }

  // If we haven't returned yet, this must be a color block
  // and we need to dynamically construct a readable section
  var background = getColorBlock(name, theme);

  // If this turns out not to be a valid colour, we give up
  // (This would happen e.g. when passing in the name of an
  // icon that doesn't have a color block)
  if (!isValidColor(background)) {
    return undefined;
  }
  var _ref2 = isDark(background) ? ['white', 'black'] : ['black', 'white'],
    _ref3 = _slicedToArray(_ref2, 2),
    contrastingText = _ref3[0],
    contrastingShade = _ref3[1];
  return _objectSpread(_objectSpread({}, localThemeSection), {}, {
    text: contrastingText,
    links: contrastingText,
    shade: contrastingShade,
    background: background
  });
}
export default getThemeSection;